import React, { Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";

export default function RouteBoundary({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [location.pathname, title]);

  return (
    <>
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="bg-white p-8 text-slate-700">
            Loading…
          </div>
        }
      >
        {children}
      </Suspense>
    </>
  );
}
